import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 7v12a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-12l6 -4l6 4","key":"svg-0"}],["path",{"d":"M10 13l2 -1l2 1","key":"svg-1"}],["path",{"d":"M10 17l2 -1l2 1","key":"svg-2"}],["path",{"d":"M10 9l2 -1l2 1","key":"svg-3"}]]

const IconMilitaryRank = createReactComponent('outline', 'military-rank', 'MilitaryRank', __iconNode);

export default IconMilitaryRank;